import { createFileRoute } from '@tanstack/react-router'

import { CommissionsPage } from '@/pages/commissions/commissions-page'

export const Route = createFileRoute('/_private/commissions')({
  component: CommissionsPage,
})
